export default "__VITE_ASSET__B4Mg9HPG__"